module.exports = __webpack_public_path__ + "static/media/bitbucket.511ec912.svg";